import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export default () => (
	<Switch>
		<Route path="/admin/convocations" exact component={List} />
		<Route path="/admin/convocations/create" component={Edit} />
		<Route path="/admin/convocations/:id" component={Edit} />
	</Switch>
);
